import React, { useState, useEffect, useRef } from "react";
import "../css/Theory2.css";
import {
  motion,
  useAnimation,
  useScroll,
  useMotionValueEvent,
  useTransform,
  MotionValue,
  AnimatePresence,
} from "framer-motion";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import NavBar_white from "./NavBar_white";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function TheoryAforismos2(props) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { t } = useTranslation();

  let navigate = useNavigate();

  const [dataFetch, setDataFetch] = useState();

  const [isTouching, setIsTouching] = useState(false);

  const { scrollY } = useScroll();

  const [isBallHovered, setIsBallHovered] = useState(false);

  const [hasAnimated, setHasAnimated] = useState(false);
  const controls = useAnimation();

  const handleTouchStart = () => {
    setIsTouching(true);
    document.getElementById("background-blurred").style.display = "none";
  };

  const handleTouchEnd = () => {
    setIsTouching(false);
    document.getElementById("background-blurred").style.display = "block";
  };

  useEffect(() => {
    const request = async () => {
      try {
        const response = await axios.get(
          `https://api.fprovidencia.com/project/getAforismos`
        );
        setDataFetch(response.data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    request();
  }, []);

  useEffect(() => {
    if (!hasAnimated) {
      controls.start("onscreen");
      setHasAnimated(true);
    }
  }, [controls, hasAnimated]);

  const hoverControl = useAnimation();
  const hoverControl2 = useAnimation();
  const ballControl = useAnimation();

  const ballhover = () => {
    ballControl.start({ opacity: 1 });
  };

  const hoverLupa = () => {
    hoverControl.start({ opacity: 1, borderColor: "white" });
    document.documentElement.style.cursor = "none";
  };

  const hoverLupaOff = () => {
    hoverControl.start({ opacity: 0, borderColor: "white" });
    hoverControl2.start({ opacity: 1 });
    document.documentElement.style.cursor = "auto";
  };

  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const mouseMove = (e) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY,
      });
    };

    window.addEventListener("mousemove", mouseMove);

    return () => {
      window.removeEventListener("mousemove", mouseMove);
    };
  }, [mousePosition]);

  const [aforismoRef, inView] = useInView({
    triggerOnce: false, // This ensures that the animation only triggers once
  });

  const [helveticaRef, inViewHelvetica] = useInView({
    triggerOnce: true, // This ensures that the animation only triggers once
  });

  const [ballRef, inViewBall] = useInView({
    triggerOnce: false, // This ensures that the animation only triggers once
  });

  const [pictoRef, inViewPictograma] = useInView({
    triggerOnce: false, // This ensures that the animation only triggers once
  });

  useEffect(() => {

    if (inViewBall === true) {
      document.documentElement.style.cursor = "none";
    } else {
      document.documentElement.style.cursor = "auto";
    }
  }, [inViewBall]);

  const useParallax = (value, distance) => {
    return useTransform(value, [0, 1], [-distance, distance]);
  };

  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref });
  const y = useParallax(scrollYProgress, 300);

  const isMobileS = useMediaQuery({ query: "(max-width: 320px)" });
  const isMobileM = useMediaQuery({
    minWidth: 321,
    maxWidth: 375,
  });
  const isMobileL = useMediaQuery({
    minWidth: 376,
    maxWidth: 425,
  });
  const isTablet = useMediaQuery({
    minWidth: 426,
    maxWidth: 768,
  });
  const isLaptop = useMediaQuery({
    minWidth: 769,
    maxWidth: 1024,
  });
  const isLaptopL = useMediaQuery({
    minWidth: 1025,
    maxWidth: 1440,
  });
  const isDesktop = useMediaQuery({
    minWidth: 1441,
    maxWidth: 1920,
  });

  const isWide = useMediaQuery({
    minWidth: 1921,
  });

  const variants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
    },
  };

  const aforismoVariants1 = {
    offscreen: { opacity: 0, x: -1000 },
    onscreen: { opacity: 1, x: 0 },
  };

  const aforismoVariants2 = {
    offscreen: { opacity: 0, x: 1000 },
    onscreen: { opacity: 1, x: 0 },
  };

  const helveticaVariants = {
    offscreen: { opacity: 0, y: 500 },
    onscreen: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 0 },
  };

  const ballVariants = {
    offscreen: { opacity: 0 },
    onscreen: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const pictogramaVariants = {
    offscreen: { opacity: 0, y: -1000 },
    onscreen: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 2000 },
  };

  const ballEnter = () => {
    setIsBallHovered(true);
    // Define the y-coordinate to scroll to (adjust as needed)
    const scrollYPosition = window.scrollY + 550;

    // Scroll to the specified position
    window.scrollTo({
      top: scrollYPosition,
      behavior: "smooth",
    });
  };

  return (
    <>
      <style>
        {`
          /* For Webkit browsers (Chrome, Safari) */
          *::-webkit-scrollbar {
            width: 0px!important; /* Adjust as needed */
          }

          *::-webkit-scrollbar {
            display: none;
          }

          *{
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */

          *::-webkit-scrollbar-thumb {
            background-color: #000; /* Color of the scrollbar thumb */
          }

          *::-webkit-scrollbar-track {
            background-color: #000; /* Color of the scrollbar track */
          }

          /* Hide scrollbar thumb on hover */
          *::-webkit-scrollbar-thumb:hover {
            background-color: #000; /* Change the color on hover */
          }
        `}
      </style>

      {/* <NavBar_white /> */}

      <AnimatePresence>
        <div className="TheorySection">
          <div className="Starting-screen" ref={ref}>
            <motion.h1
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 0.4 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 2, ease: "easeInOut" }}
              style={{ pointerEvents: "none" }}
            >
              {t("theoryAforismos.scroll")}
            </motion.h1>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1">
            <div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo1_animation"
              />

              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo1_text_title"
              >
                <h1>{t("theoryAforismos.1.title")}</h1>
                <p>{t("theoryAforismos.1.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo1_text_body"
              >
                <p>{t("theoryAforismos.1.content")}</p>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1">
            <div ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo1_img"
                style={{ position: "relative", overflow: "hidden" }}
              >
                <img src="images/Theory/Aforismos/rosedown.png"></img>
                <div className="gradient-overlay"></div>
                <div
                  onClick={() => {
                    navigate("/ProjectInfo/candeeiro-rose-down", {
                      state: dataFetch[0],
                    }); // Pass 'item' as an argument
                    window.scrollTo(0, 0); // Scroll to the top of the page
                  }}
                  className="Aforismo1_img_info"
                >
                  <div>
                    <h1>{t("theoryAforismos.1.caption_title")}</h1>
                    <p>{t("theoryAforismos.1.caption_body")}</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1">
            <motion.div className="Aforismo1_elements" ref={ref}>
              {currentLanguage === "pt" ? (
                <motion.img
                  initial="offscreen"
                  whileInView="onscreen"
                  variants={variants}
                  exit="offscreen"
                  transition={{ duration: 2, ease: "easeInOut" }}
                  className="Aforismo2_animation"
                  src="/images/Theory/Aforismos/Anim/Hand_PT.png"
                />
              ) : (
                <motion.img
                  initial="offscreen"
                  whileInView="onscreen"
                  variants={variants}
                  exit="offscreen"
                  transition={{ duration: 2, ease: "easeInOut" }}
                  className="Aforismo2_animation"
                  src="/images/Theory/Aforismos/Anim/Hand_EN.png"
                />
              )}
              <div className="teste">
                <motion.div
                  initial="offscreen"
                  whileInView="onscreen"
                  variants={variants}
                  exit="offscreen"
                  transition={{ duration: 2, ease: "easeInOut" }}
                  className="Aforismo2_text_body"
                >
                  <p>{t("theoryAforismos.2.content")}</p>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo1_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/Museu_de_Penafiel_Cover.png"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/museu-municipal-de-penafiel", {
                    state: dataFetch[1],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.2.caption_title")}</h1>
                  <p>{t("theoryAforismos.2.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1" ref={ref}>
            <motion.div className="Aforismo3_elements" ref={pictoRef}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo3_line"
              ></motion.div>
              <motion.img
                initial="offscreen"
                animate={inViewPictograma ? "onscreen" : "offscreen"}
                exit="exit"
                variants={pictogramaVariants}
                transition={{
                  opacity: { duration: 2, ease: "easeInOut" },
                  y: { duration: 1, ease: "easeInOut" },
                }}
                className="Aforismo3_animation"
                src="/images/Theory/Aforismos/Anim/Asset 32@4x.png"
              />
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo3_text_title"
              >
                <h1>{t("theoryAforismos.3.title")}</h1>
                <p>{t("theoryAforismos.3.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo3_text_body"
              >
                <p>{t("theoryAforismos.3.content")}</p>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo3_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              {isLaptop || isLaptopL || isDesktop || isWide ? (
                <img src="images/Theory/Aforismos/Pictos_Web_Cover.gif"></img>
              ) : (
                <img src="images/Theory/Aforismos/Pictos_Mobile_Cover.gif"></img>
              )}
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/pictogramas", {
                    state: dataFetch[2],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.3.caption_title")}</h1>
                  <p>{t("theoryAforismos.3.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.img
                initial={
                  isLaptopL || isDesktop || isWide
                    ? { opacity: 0, x: 1000 }
                    : { opacity: 0, x: 250 }
                }
                whileInView={{ opacity: 1, x: 0 }}
                variants={variants}
                exit={{ opacity: 0, x: 1000 }}
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo4_animation"
                src="/images/Theory/Aforismos/Anim/Asset 34@4x.png"
              />

              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo4_text_title"
              >
                <h1>{t("theoryAforismos.4.title")}</h1>
                <p>{t("theoryAforismos.4.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo4_text_body"
              >
                <p>{t("theoryAforismos.4.content")}</p>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo1_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/Candeeiro17graus_Cover.jpg"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/candeeiro-17º-(larus-design)", {
                    state: dataFetch[6],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.4.caption_title")}</h1>
                  <p>{t("theoryAforismos.4.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo5">
            <div className="Aforismo5_elements" ref={ref}>
              <div className="Aforismos5_animation_grid" ref={helveticaRef}>
                <motion.img
                  initial="offscreen"
                  animate={controls}
                  variants={variants}
                  exit="offscreen"
                  transition={{ duration: 2, ease: "easeInOut" }}
                  className="Aforismo5_animation_1"
                  src="/images/Theory/Aforismos/Anim/Helv@4x.png"
                />
                <motion.img
                  initial={inViewHelvetica ? { opacity: 1, y: 0 } : "offscreen"}
                  animate={inViewHelvetica ? "onscreen" : "undefined"}
                  exit="exit"
                  variants={helveticaVariants}
                  transition={{
                    opacity: { duration: 2, ease: "easeInOut" },
                    y: { duration: inViewHelvetica ? 1 : 0, ease: "easeInOut" },
                  }}
                  className="Aforismo5_animation_2"
                  src="/images/Theory/Aforismos/Anim/ética_2@4x.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <motion.div className="Aforismo1_elements" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo5_text_title"
            >
              <h1>{t("theoryAforismos.5.title")}</h1>
              <p>{t("theoryAforismos.5.subtitle")}</p>
            </motion.div>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo5_text_body"
            >
              <p>{t("theoryAforismos.5.content")}</p>
            </motion.div>
          </motion.div>
        </div>

        <div className="TheorySection">
          <motion.div
            whileInView={hoverLupaOff}
            className="Aforismo5"
            ref={ref}
          >
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo5_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/Helvetica_Cover_Theory.png"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate(
                    "/ProjectInfo/cartaz-comemorativo-dos-50-anos-da-tipografia-helvética",
                    {
                      state: dataFetch[3],
                    }
                  ); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.5.caption_title")}</h1>
                  <p>{t("theoryAforismos.5.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1">
            {isWide || isDesktop || isLaptopL ? (
              <div
                className="mouse-parallax-container"
                id="mouse-parallax-container"
                ref={ref}
              >
                <div className="background-blurred" id="background-blurred">
                  <motion.div className="Aforismo1_elements">
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_title"
                    >
                      <h1>{t("theoryAforismos.6.title")}</h1>
                      <p>{t("theoryAforismos.6.subtitle")}</p>
                    </motion.div>
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_body"
                    >
                      <p>{t("theoryAforismos.6.content")}</p>
                    </motion.div>
                  </motion.div>
                </div>
                <div
                  className="background-unblurred"
                  style={{
                    clipPath: `circle(50px at ${mousePosition.x}px ${mousePosition.y}px)`,
                  }}
                >
                  <motion.div className="Aforismo1_elements">
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_title"
                    >
                      <h1>{t("theoryAforismos.6.title")}</h1>
                      <p>{t("theoryAforismos.6.subtitle")}</p>
                    </motion.div>
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_body"
                    >
                      <p>{t("theoryAforismos.6.content")}</p>
                    </motion.div>
                  </motion.div>
                </div>
                <motion.div
                  initial={{ opacity: 1, borderColor: "white" }}
                  whileInView={hoverLupa}
                  exit={{ opacity: 0 }}
                  className="mouse-cursor"
                  style={{
                    top: `${mousePosition.y}px`,
                    left: `${mousePosition.x}px`,
                  }}
                ></motion.div>
              </div>
            ) : (
              <div
                className="mouse-parallax-container"
                id="mouse-parallax-container"
                ref={ref}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                <div className="background-blurred" id="background-blurred">
                  <motion.div className="Aforismo1_elements">
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_title"
                      style={{ pointerEvents: "none" }}
                    >
                      <h1>{t("theoryAforismos.6.title")}</h1>
                      <p>{t("theoryAforismos.6.subtitle")}</p>
                    </motion.div>
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_body"
                      style={{ pointerEvents: "none" }}
                    >
                      <p>{t("theoryAforismos.6.content")}</p>
                    </motion.div>
                  </motion.div>
                </div>
                <div
                  className="background-unblurred"
                  style={{
                    top: 0,
                  }}
                >
                  <motion.div className="Aforismo1_elements">
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_title"
                      style={{ pointerEvents: "none" }}
                    >
                      <h1>{t("theoryAforismos.6.title")}</h1>
                      <p>{t("theoryAforismos.6.subtitle")}</p>
                    </motion.div>
                    <motion.div
                      initial="offscreen"
                      whileInView="onscreen"
                      variants={variants}
                      exit="offscreen"
                      transition={{ duration: 2, ease: "easeInOut" }}
                      className="Aforismo6_text_body"
                      style={{ pointerEvents: "none" }}
                    >
                      <p>{t("theoryAforismos.6.content")}</p>
                    </motion.div>
                  </motion.div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo1" ref={ref}>
            <motion.div
              initial={{ opacity: 1 }}
              whileInView={hoverLupaOff}
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo1_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/Contentores_Cover.jpg"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/barreira-de-contentores", {
                    state: dataFetch[4],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.6.caption_title")}</h1>
                  <p>{t("theoryAforismos.6.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo6">
            <div className="Aforismo6_elements" ref={ref}>
              <motion.img
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo6_animation"
                src="/images/Theory/Aforismos/UA_Morph.gif"
              />
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo6">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo6_text_title"
              >
                <h1>{t("theoryAforismos.7.title")}</h1>
                <p>{t("theoryAforismos.7.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo6_text_body"
              >
                <p>{t("theoryAforismos.7.content")}</p>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo6" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo6_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              {isLaptopL || isDesktop || isWide ? (
                <img src="images/Theory/Aforismos/UA_Web_Cover.gif"></img>
              ) : (
                <img src="images/Theory/Aforismos/UA_Mobile_Cover.gif"></img>
              )}
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/universidade-de-aveiro", {
                    state: dataFetch[5],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.7.caption_title")}</h1>
                  <p>{t("theoryAforismos.7.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo7" ref={ref}>
            <div className="Aforismo7_elements" ref={ballRef}>
              {isBallHovered === true ? (
                <motion.img
                  initial="offscreen"
                  whileInView="onscreen"
                  variants={variants}
                  exit="offscreen"
                  transition={{ duration: 2, ease: "easeInOut" }}
                  className="Aforismo7_animation"
                  src="/images/Theory/Aforismos/Circle_Design_Participativo4x.png"
                />
              ) : (
                <>
                  <motion.div
                    initial="offscreen"
                    whileInView={ballhover}
                    animate={ballControl}
                    variants={variants}
                    exit="offscreen"
                    style={{
                      top: `${mousePosition.y}px`,
                      left: `${mousePosition.x}px`,
                    }}
                    className="cursor"
                    id="cursor"
                  ></motion.div>
                  <motion.svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width={1002}
                    height={1002}
                    viewBox="0 0 1002 1002"
                    initial="offscreen"
                    whileInView="onscreen"
                    variants={ballVariants}
                    exit="offscreen"
                    transition={{ duration: 2, ease: "easeInOut" }}
                    className="Aforismo7_animation"
                    {...props}
                  >
                    <image
                      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMkAAADJCAYAAACJxhYFAAAIsUlEQVR4nO3dLXPbShSA4dOOgYCBgYGBQUBAQED//68oCAgICDAwMDAwMNBMOnLPJrKsb+1K+/E+M5lM752510399uyuZfnX19eXwJm1iKxK3wubyv+s+uuqXEQupX9W/vVFf33VLzhAJHZsNISs9D1b4HFcNJZL6Yt4JiKS4TKNwoSx9vzxmslz1i8zfdATkXQrlknbUhhLTAjbilBOpXDQgkjqrTWIXQCTYqpcQznpF1Omgkh+ZBrFLpJpMdaJYO6lHolZSu0TmBhD5RrKMfUlWaqRrDWMnQePJQTFCdlBg0luuqQWiVlOdb02gWZFKJ8pHS2nEIlZUj0lvtew7ayxRL8UizmSlS6p9qVXu2Ff9LHEGsleJwdxzCfaWGKLZMeyanHFidhHTHuWWCLZaBxsyP1x0MkS/GlY6JEUy6lnjnK9letUOYb8mwg5kuLE6oV9RxCKfcp7qEuwECPJNA6WVmHJdfl1CO2BhxbJTpdXTI9wBTdVQolkpdNj68FjwXRB7VVCiGSjgXCsG5+TThWvT8B8j2SvyyvEq1h2vVXex+8VXyNheZUWr5dfPkay1kB4f0d6jrr88opvkRT7j1dOr5J21uWXN/sUnyLZ6QQBLhqKF8fEvkTypF+AUUySvz5s6H2I5IVrr9DAi1CWjoRA0GXxk68lIyEQDPG+VCi/F/pjIhAMtdhzZolICARjLfLcmTsSAsFUs79NYs5ICAS2vM55RcZckXC3RNhUXJHxZ65Q5ohkx5W8cGA11yVMriNZc6kJHMp0ojgNxWUk5jcAuLR2vVJxFclsoxDQJf3e1Q/CVSTPvB8EM3t2dTTsIhJOsrCUVxf3QrAdifP1IdDCLPOtshmJkwcIDLS2/d4km5E8c9sfeMLqzdNtRbJlHwLPWLtPtI1IVrxgCA9ltpZdNiLhzu7w1d7GsmtqJFtuIAfPTf5LfEokK457EYBs6qvxUyLZc5qFQDxNuQJkbCTWNkXATEavesZGwmkWQrMZu38eE8mGj2JDoEZNkzGRMEUQqlGb+KGR7NisI3BPQ4+Eh0bCZh2hWw2dJkMiYYogFvsh02RIJEwRxGLQNOkbCVMEsek9TfpGwhRBbFZ9XzfpE8mGKYJI9frLv08kzm7VAiws6zNNuiLp9R8BAtY5BLoiYYogdp3bia5IeN86UtA6DNoi2fK2XCSidRi0RcIUQSpaj4ObIul9hgxEYnAkBILU7Jq2F0QC/Kh93tdFwlILqeodCYEgVbVvSycS4EftKqouEm7ygJQ9PP+rkWx4ARGJ65wkTBGkLqtey1WNhP0IUBkW1Uj4xFygJRKWWsB/RAJ0yMoHWEQC1PvuoRwJ+xHgx3cPJpKM10eAOw+ThFsGAfe+mzCRsB8B7j1EwiQBHt2GB5EAzW5dmEg42QIe3UXCyRbw6DY8fjNFgEa34fGbKQI0+l5usWkH6hEJ0MeYz3EHUrJmTwK0W3G6BXRguQV0IBKg3YpIgHZrIgE6EAnQgUiADkQCdCASoAORAO2uRAK0IxKgSxFJzk8JaFZEcuHnAzRjuQW0O7PcAjqw3AKa3QYIyy2g2W2AFJGc+SEBzZgkQLPbADGRME2AR3d7Ek64gEffexLhhAuodRUiARrl1Uiu/KyAO9+Dg0kC1HuIRDjhAu7URsI0AX4wSYAWOZMEaHc3MMqRXDnlAm4aI3n4l0CiiARokVe3HtVITvz0kLiHQVGN5KEiIDEPg6Lu/SRHnhVIWK9I2JcgVZe6t43URXLhKBiJql1FNb19lw08UlT7vG+KhH0JUtO4gmqK5MIpFxJzaPrttt0thWmClDRuMYgE+P9cb7wZSlskOaEgEa3P866b0xEJYnftem2wK5Izr5kgco0bdqPPbU4/eZYgUr22FH0iOXGHR0SqdcNu9Ikk7zOSgAD1el73vav8gWmCyBz77rf7RsI0QWx677WHfD4J0wSx6D1FZGAkTBPEYtCJ7dBPumKaIHSDpoiMiIRpgpDlY173G/OZiZ+8Co9AHcY8d8d+sOgHzxIE5jp2FTQ2khM3jEBgPsbup6d8RPU7zxIE4jzlvg1TIrly8SMCMekv9CmRCJt4BGDyc3RqJMKyCx672Fjt2IjkzGsn8JSVv8BtRCJ6csAtiOATa89JW5EIyy54xOrqxmYkF15khAeK10LebD4Mm5GI1st9hLGkN9sX4dqORHTZxf4ES/h0cSWIi0hyDYVL6jGnk6sXt11EIjpJ2MhjLk6fb64iEZdlAyXOVy4uIxGNhFulwqU313tg15GIVs5l9XBhlufWHJHIHLUjOR9zrVLmiqRYL/4lFFhynPN6wbkikVIoHA1jiuPcJ6dzRiKEgolmD0QWiER0yUUoGGqRQAq/vr6+lvrTWovIi34H2iwWiCwcSWElIn8IBS0WDUQ8iEQIBS3efXgx2odIREN5FpGdB48FfvAiEPEoEuOFUJLn3WtqvkUiGsmLB48D87v4+H4kHyMR3Z/80WUY0nDy9X1IvkYibOiT8unz2yp8jsQoNvR7Px4KLDM3bfD6KvEQIilsROSV5VdUvF1eVYUSiWggxYZ+68FjwXjm06aCuetnSJEYW42FqRKes06PoG6yHmIkwlQJTnDToyzUSIytbuwzPx4Oapz0XYTBfkRH6JGITpXi9OvJg8eCH9dY7m8QQyRGplOFJdiygl5a1YkpEmOjU2Xjx8NJhvmM/0Nsb6iLMRKDWOZzjPmjAWOOxCAWN/LSXUui/tzMFCIxNnqFMZfiTxPtsqpJSpEYmYay5wXJQc46OZK7bW2KkZTt9DSME7F6xaQ46dRI9saCqUdiZBrKjkvzb046MZL/1DIhklopBpPrcuqkX9wTrYRI2mW64d/q95j2MFcN4szEaEckw6w1lk2A0Vz066xfUR/b2kQk02Qajokn8+RiSxPEVYO4sIQaj0jcMFNmXfoupV9PdS1NgnPpe87HW9hHJMsZOnX4tLAliMg/3GI7+QbDXPIAAAAASUVORK5CYII="
                      width={201}
                      height={201}
                      x={117}
                      y={118}
                    />
                    <image
                      xlinkHref="data:img/png;base64,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"
                      width={200}
                      height={201}
                      y={401}
                    />
                    <image
                      xlinkHref="data:img/png;base64,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"
                      width={201}
                      height={201}
                      x={117}
                      y={684}
                    />
                    <image
                      id="ball8"
                      onMouseEnter={ballEnter}
                      xlinkHref="data:img/png;base64,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"
                      width={201}
                      height={200}
                      x={400}
                      y={802}
                    />
                    <image
                      xlinkHref="data:img/png;base64,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"
                      width={201}
                      height={201}
                      x={683}
                      y={684}
                    />
                    <image
                      xlinkHref="data:img/png;base64,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"
                      width={201}
                      height={201}
                      x={801}
                      y={401}
                    />
                    <image
                      xlinkHref="data:img/png;base64,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"
                      width={201}
                      height={201}
                      x={683}
                      y={118}
                    />
                    <image
                      xlinkHref="data:img/png;base64,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"
                      width={201}
                      height={201}
                      x={400}
                    />
                  </motion.svg>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo7">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo7_text_title"
              >
                <h1>{t("theoryAforismos.8.title")}</h1>
                <p>{t("theoryAforismos.8.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo7_text_body"
              >
                <p>{t("theoryAforismos.8.content")}</p>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo7" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo7_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/labPoetico_Cover.png"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/candeeiro-laboratório-poético", {
                    state: dataFetch[7],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.8.caption_title")}</h1>
                  <p>{t("theoryAforismos.8.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo8">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo8_grid_title"
              >
                <h1 className="Aforismo8_title1">Roger Cook, 1974</h1>
                <h1 className="Aforismo8_title2">Max Ponty, 1947</h1>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo8" ref={ref}>
            <div className="Aforismo7_elements" ref={aforismoRef}>
              <motion.img
                initial="offscreen"
                animate={inView ? "onscreen" : "offscreen"}
                exit="offscreen"
                variants={aforismoVariants1}
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo8_animation1"
                src="/images/Theory/Aforismos/Roger_Cook_Man@4x.png"
              ></motion.img>
              <motion.img
                initial="offscreen"
                animate={inView ? "onscreen" : "offscreen"}
                exit="offscreen"
                variants={aforismoVariants2}
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo8_animation2"
                src="/images/Theory/Aforismos/Max_Ponty_Gitanes@4x.png"
              ></motion.img>
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo8">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo8_text_title"
              >
                <h1>{t("theoryAforismos.9.title")}</h1>
                <p>{t("theoryAforismos.9.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo8_text_body"
              >
                <p>{t("theoryAforismos.9.content")}</p>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo8" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo8_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/Cigadania_Cover.png"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/cartaz-cigadania", {
                    state: dataFetch[8],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.9.caption_title")}</h1>
                  <p>{t("theoryAforismos.9.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo6">
            <div className="Aforismo6_elements" ref={ref}>
              <motion.img
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo9_animation"
                src="/images/Theory/Aforismos/Aforismo10_Imaginar.gif"
              />
            </div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo6">
            <motion.div className="Aforismo1_elements" ref={ref}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo6_text_title"
              >
                <h1>{t("theoryAforismos.10.title")}</h1>
                <p>{t("theoryAforismos.10.subtitle")}</p>
              </motion.div>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                variants={variants}
                exit="offscreen"
                transition={{ duration: 2, ease: "easeInOut" }}
                className="Aforismo6_text_body"
              >
                <p>{t("theoryAforismos.10.content")}</p>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="Aforismo6" ref={ref}>
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={variants}
              exit="offscreen"
              transition={{ duration: 2, ease: "easeInOut" }}
              className="Aforismo9_img"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img src="images/Theory/Aforismos/BiD_2016_B_Cover.png"></img>
              <div className="gradient-overlay"></div>
              <div
                onClick={() => {
                  navigate("/ProjectInfo/malga-bid-2016", {
                    state: dataFetch[9],
                  }); // Pass 'item' as an argument
                  window.scrollTo(0, 0); // Scroll to the top of the page
                }}
                className="Aforismo1_img_info"
              >
                <div>
                  <h1>{t("theoryAforismos.10.caption_title")}</h1>
                  <p>{t("theoryAforismos.10.caption_body")}</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="TheorySection">
          <div className="AforismosFooter">
            <motion.h1
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 0.4 }}
              whileHover={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, ease: "easeInOut" }}
              style={{ pointerEvents: "all" }}
            >
              <Link to="/#Work">{t("theoryAforismos.end")}</Link>
            </motion.h1>
          </div>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2, ease: "easeInOut" }}
            style={{ position: "sticky", bottom: 0, left: 0 }}
          >
            <Footer bg="black"></Footer>
          </motion.div>
        </div>
      </AnimatePresence>
    </>
  );
}

export default TheoryAforismos2;
